import * as a from '@mitranim/js/all.mjs'
import * as dr from '@mitranim/js/dom_reg.mjs'
import * as u from './util.mjs'
import {A, E} from './util.mjs'
import * as c from './conf.mjs'
import * as es from './elem-sugg.mjs'
import * as ei from './elem-input.mjs'

export class MdTextarea extends ei.Textarea {
  static {dr.reg(this)}

  connectedCallback() {
    super.connectedCallback()
    this.onkeydown = this.onKeydown
  }

  disconnectedCallback() {
    super.disconnectedCallback?.()
    this.suggs()?.remove()
  }

  onKeydown(eve) {
    if (u.isEventModifiedPrimary(eve) && eve.key === `b`) {
      a.eventKill(eve)
      this.bold()
      return
    }

    if (u.isEventModifiedPrimary(eve) && eve.key === `i`) {
      a.eventKill(eve)
      this.italic()
      return
    }

    if (u.isEventModifiedPrimary(eve) && eve.key === `'`) {
      a.eventKill(eve)
      this.strike()
      return
    }

    this.maybeSubmitForm(eve)
    if (eve.defaultPrevented) return

    this.onKeydownForSuggs(eve)
  }

  /*
  Technical note. Special keys such as enter, escape, or arrows, can be detected
  only on keydown, not on keypress. However, keydown happens before the cursor
  position is updated, and before text is updated. This means any information
  about the cursor position that we use here usually becomes outdated
  immediately after the event.
  */
  onKeydownForSuggs(eve) {
    const suggs = this.suggs()
    if (!suggs) return undefined

    const ind = this.selectionStart
    const start = suggs.start()
    const end = suggs.end()

    /*
    If the cursor is outside the text that triggered the suggestions,
    the suggestions no longer interest us.
    */
    if (!(ind >= start && ind <= end)) return suggs.remove()

    if (
      false
      || (eve.key === c.KEY_ARROW_LEFT && (eve.shiftKey || (ind - 1) <= start))
      || (eve.key === c.KEY_ARROW_RIGHT && (eve.shiftKey || ind >= end))
    ) return suggs.remove()

    if (eve.key === c.KEY_ARROW_UP) {
      if (eve.shiftKey) return suggs.remove()
      a.eventKill(eve)
      return suggs.cyclerPrev()
    }

    if (eve.key === c.KEY_ARROW_DOWN) {
      if (eve.shiftKey) return suggs.remove()
      a.eventKill(eve)
      return suggs.cyclerNext()
    }

    if (eve.key === c.KEY_ENTER) {
      a.eventKill(eve)
      return suggs.commitCurrent()
    }

    if (eve.key === c.KEY_ESCAPE) {
      a.eventKill(eve)
      return suggs.remove()
    }

    return undefined
  }

  onInput(eve) {
    super.onInput(eve)
    this.mentions()
  }

  bold() {return this.toggleWrapSel(`**`)}
  italic() {return this.toggleWrapSel(`_`)}
  strike() {return this.toggleWrapSel(`~~`)}
  img(src) {return this.replaceSel(u.mdImg(``, src))}

  /*
  Support for providing suggestions when typing new mentions such as
  `@some_slug` or updating existing mentions such as `<@some_uuid>`.

  TODO generalize. We might want something similar for other features,
  not just for mentions. Please do not copy-paste.
  */
  mentions() {
    if (this.hasSel()) return undefined

    // Note: we must scan in both directions around the cursor, because the
    // cursor may be in the middle of `@some_text`.
    const pre = this.cursorPre()
    const suf = this.cursorSuf()

    const matPre = pre.match(
      this.suggs()
      ? /@([\p{L}\d_. -]*)$/u
      : /@([\p{L}\d_.-]*)$/u
    )

    if (!matPre) return this.suggsRemove()

    const matSuf = suf.match(/^[\p{L}\d_.-]*/u)
    const textPre = a.reqStr(matPre[1])
    const textSuf = a.laxStr(matSuf[0])
    const text = textPre + textSuf
    const ind = this.selectionStart

    return this.suggsReinit({
      start: ind - a.reqStr(matPre[0]).length,
      end: ind + textSuf.length,
      text,
    })
  }

  get Suggs() {return es.PersonSuggs}
  suggsId() {return this.dataset.suggsId ||= this.ctx.seq.nextId()}
  suggs() {return u.elemById(this.suggsId())}
  suggsReinit(inp) {this.suggsEnsure().reinit(inp)}
  suggsRemove() {this.suggs()?.remove()}

  suggsEnsure() {
    return (
      this.suggs() ||
      this.appendSibling(E(new this.Suggs().init(), A.id(this.suggsId())))
    )
  }

  replaceMention({start, end, text}) {
    a.reqInt(start)
    a.reqInt(end)
    a.reqStr(text)

    /*
    The provided range `[start, end]` is assumed to include the preceding `@`.
    Note: `.setRangeText` doesn't add an "undo" entry. See `.replaceSel`.
    TODO fix.
    */
    this.setRangeText(
      u.slugMention(a.reqStr(text)),
      start,
      end,
      // Cursor position mode. "end" moves it to just after the replacement.
      `end`,
    )
  }
}
